import { render, staticRenderFns } from "./messageManage.vue?vue&type=template&id=10693812&scoped=true&"
import script from "./messageManage.vue?vue&type=script&lang=js&"
export * from "./messageManage.vue?vue&type=script&lang=js&"
import style0 from "./messageManage.vue?vue&type=style&index=0&id=10693812&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10693812",
  null
  
)

export default component.exports